module.exports = __webpack_public_path__ + "assets/img/961717a5c1aac0c52e2c6941cd67516f.svg";